<template>
	<div>
		<form class="toolbar">
			<fieldset class="toolbar__filters">
				<div class="flex-fix">
					<FormControlDatepicker name="fromDate" v-model="formData.fromDate" label="From date">
					</FormControlDatepicker>
					<FormControlDatepicker name="toDate" v-model="formData.toDate" label="To date">
					</FormControlDatepicker>
				</div>
			</fieldset>
			<fieldset class="toolbar__search">
				<div class="flex-fix">
					<span v-if="resultCount !== null">Matches {{ resultCount }} insights</span>
				</div>
			</fieldset>
		</form>
	</div>
</template>

<script>
	import API from '../../../api';
	import ListReports from '../../List/ListReports';
	import FormControlSector from '../../Form/Control/FormControlSector';
	import FormControlDatepicker from '../../Form/Control/FormControlDatepicker';
	import ReportTab from './ReportTab';

	export default {
		name: 'ReportTabInsights',
		mixins: [ReportTab],
		components: {
			FormControlDatepicker,
			FormControlSector,
			ListReports,
		},
		data() {
			return {
				formData: {
					fromDate: null,
					toDate: null,
					mandated: false,
				},
			}
		},
		methods: {
			fetchResourceCount() {
				return API.getInsights(this.formData).then(response => {
					return response.meta.total;
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
</style>
